// extracted by mini-css-extract-plugin
module.exports = {"tile":"Home_tile__TX2p2","tileInner":"Home_tileInner__3W9Lq"};